module.exports = __webpack_public_path__ + "img/workers.4ed5b58c.svg";